import { Directive, HostBinding, Inject, Input } from '@angular/core';
import { STATUS_COLOR_DEFAULT_CONFIG } from './status-color-default-config';

@Directive({
  selector: 'mat-chip[labsStatusColor], labs-status-badge[labsStatusColor]'
})
export class StatusColorDirective {
  @HostBinding('style.background-color') get backgroundColor() {
    return this.statusColorConfig[this.statusColor].backgroundColor;
  }
  @HostBinding('style.color') get textColor() {
    return this.statusColorConfig[this.statusColor].foregroundColor;
  }
  // tslint:disable-next-line: no-input-rename
  @Input('labsStatusColor') statusColor: string;

  constructor(@Inject(STATUS_COLOR_DEFAULT_CONFIG) private statusColorConfig) {}
}
